import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

const ViewProviderHandicapAccessible = ({ office }) => {
  const { t } = useTranslation();

  return (
    <>
      {office?.isHandicapAccessible == "Y" && (
        <span className="details-subheader">{t(`HandicapAccessible`)}: </span>
      )}
      {office?.isHandicapAccessible == "Y" && (
        <span style={{ color: "#000" }}> {t(`yes`)} </span>
      )}

      {office?.isHandicapAccessible == "N" && (
        <span className="details-subheader">{t(`HandicapAccessible`)}: </span>
      )}
      {office?.isHandicapAccessible == "N" && (
        <span style={{ color: "#000" }}>{t(`no`)} </span>
      )}
    </>
  );
};

ViewProviderHandicapAccessible.propTypes = {
  office: PropTypes.object,
};

export default ViewProviderHandicapAccessible;
